import React, { Component } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CrashFallback from './CrashFallback';
import { captureClientCrash } from '../../monitoring/telemetry';

class RouteErrorBoundaryInner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorId: '',
      resetKey: 0,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const crashEvent = captureClientCrash(error, {
      boundaryScope: this.props.scope,
      boundaryPath: this.props.routePath,
      feature: this.props.feature,
      componentStack: errorInfo?.componentStack || '',
      pathname: this.props.pathname,
    });

    this.setState({
      errorId: crashEvent.errorId,
    });
  }

  handleRetry = () => {
    this.setState((prev) => ({
      hasError: false,
      errorId: '',
      resetKey: prev.resetKey + 1,
    }));
  };

  render() {
    if (this.state.hasError) {
      return (
        <CrashFallback
          errorId={this.state.errorId}
          onRetry={this.handleRetry}
          onGoHome={this.props.onGoHome}
          onGoBack={this.props.onGoBack}
        />
      );
    }

    return <React.Fragment key={this.state.resetKey}>{this.props.children}</React.Fragment>;
  }
}

export default function RouteErrorBoundary({
  children,
  routePath,
  feature,
  scope = 'route',
}) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RouteErrorBoundaryInner
      routePath={routePath}
      feature={feature}
      scope={scope}
      pathname={location.pathname}
      onGoHome={() => navigate('/dashboard')}
      onGoBack={() => navigate(-1)}
    >
      {children}
    </RouteErrorBoundaryInner>
  );
}
